import { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import styles from './index.module.less';
import BackTop from './BackTop';
import Intercom from './Intercom';
import gsap from 'gsap';
import MobxWrap from '../MobxWrap';
import { useThrottleFn } from 'ahooks';

const Udesk = dynamic(() => import('./Udesk'), { ssr: false });

const Index = MobxWrap(['area', 'app', 'meta'], (props) => {
  const { changePageToolBarPosition } = props.meta;
  const {
    country: { code, language },
  } = props.area;
  const { setGlobalValue, G_HideFooterSubscribe, showUDesk } = props.app;
  const initCustomerService = typeof showUDesk === 'boolean';
  const [visible, setVisible] = useState(false); // 默认是false，避免首次展示的位置和changePageToolBarPosition后面变更的位置不一致，造成ICON滑动
  const toolBarRef = useRef(null);
  const scrollTimer = useRef(null);

  const { run: onScroll } = useThrottleFn(
    () => {
      clearTimeout(scrollTimer.current);
      onVisibleAni(false);

      scrollTimer.current = setTimeout(() => {
        onVisibleAni(true);
      }, 300);
    },
    { wait: 200 }
  );

  const onVisibleAni = (visible) => {
    setVisible(visible);
    const visibleStyle = {
      duration: 0.2,
      opacity: 1,
      onStart: () => {
        gsap.set(toolBarRef.current, { display: 'flex' });
      },
    };

    const hideStyle = {
      duration: 0.2,
      opacity: 0,
      onComplete: () => {
        gsap.set(toolBarRef.current, { display: 'none' });
      },
    };

    gsap.to(toolBarRef.current, visible ? visibleStyle : hideStyle);
  };

  useEffect(() => {
    const _showUDesk = ['zh_CN', 'zh_TW'].includes(language);
    setGlobalValue('showUDesk', _showUDesk);

    // 调整toolBar位置，在此之前工具栏隐藏（避免上下滑动）
    changePageToolBarPosition(undefined, () => {
      setTimeout(() => {
        // 设置了正确的高度后允许展示工具栏高度,设置500ms间隔避免设置了高度后马上滑动被看到(StickyBar客户端渲染获取DOM节点高度有延迟)
        onVisibleAni(true);
      }, 500);
    });

    // 滑动时自动消失,停止滑动时出现
    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <div
      id='fixedToolBar'
      className={styles.toolBar}
      data-visible={visible}
      data-c={code}
      data-small={`${G_HideFooterSubscribe}`}
      ref={toolBarRef}
    >
      <BackTop />
      {initCustomerService && showUDesk && <Udesk />}
      {initCustomerService && !showUDesk && <Intercom />}
    </div>
  );
});

export default Index;
